import * as React from 'react';
import { cn } from '@/hen-ui/utils';
import { Heading } from '@/hen-ui/atomics/Heading';
import { Icon } from '@/hen-ui/atomics/Icon';

export interface TimelineEventProps
  extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  index: number;
  children?: React.ReactNode;
}

const ICON_SIZE = '30px';

/**
 * TimelineEvent component renders a single event in the timeline.
 * Composed of Heading for the title and Text for the description.
 */
export const TimelineEvent = React.forwardRef<
  HTMLDivElement,
  TimelineEventProps
>(({ title, index, className, children, ...props }, ref) => {
  return (
    <div ref={ref} className={cn('relative', className)} {...props}>
      <div className='flex flex-col gap-xs'>
        {/* Heading row with icon */}
        <div className='flex gap-xxs items-center'>
          {/* Left column: Marker */}
          <div className='flex-shrink-0 relative flex items-center justify-center'>
            <Icon
              icon='circle'
              size='lg'
              color='primary'
              style={{ width: ICON_SIZE, height: ICON_SIZE }}
              aria-hidden='true'
            />
          </div>

          {/* Right column: Title */}
          <div className='flex-1'>
            <Heading variant='h4'>{title}</Heading>
          </div>
        </div>

        {/* Description row expects TimelineEventDescription */}
        <div>{children}</div>
      </div>
    </div>
  );
});

TimelineEvent.displayName = 'TimelineEvent';
